import { z } from 'zod';
import { FactsSchema } from './valuation-facts';
import { ISODateSchema } from './common';
import { RegionTypeSchema } from './market-data';
export const GeographicRegionTypeSchema = RegionTypeSchema.exclude(['Postleitzahl']);
const GeographicOriginShape = {
    title: z.string(),
    link: z.string(),
    date: ISODateSchema.optional(),
};
export const GeographicOriginSchema = z.object(GeographicOriginShape);
const GeographicRegionShape = {
    code: z.string().optional(),
    name: z.string(),
    type: GeographicRegionTypeSchema.optional(),
};
export const GeographicRegionSchema = z.object(GeographicRegionShape);
const NumberFactSchema = FactsSchema.shape.time_series.element.options[0];
const PercentageFactSchema = FactsSchema.shape.time_series.element.options[1];
const MonetaryFactSchema = FactsSchema.shape.time_series.element.options[2];
const MoneyPerAreaFactSchema = FactsSchema.shape.time_series.element.options[3];
const GeographicSeriesShape = {
    title: z.string(),
    origin: GeographicOriginSchema.optional(),
    description: z.string().optional(),
    region: GeographicRegionSchema,
    topic: NumberFactSchema.shape.topic,
    stats_type: NumberFactSchema.shape.stats_type,
    period: NumberFactSchema.shape.period,
};
const NumberSeriesShape = { ...GeographicSeriesShape, value_type: NumberFactSchema.shape.value_type, values: NumberFactSchema.shape.values };
const NumberSeriesSchema = z.object(NumberSeriesShape);
const PercentageSeriesShape = { ...GeographicSeriesShape, value_type: PercentageFactSchema.shape.value_type, values: PercentageFactSchema.shape.values };
const PercentageSeriesSchema = z.object(PercentageSeriesShape);
const MonetarySeriesShape = { ...GeographicSeriesShape, value_type: MonetaryFactSchema.shape.value_type, values: MonetaryFactSchema.shape.values };
const MonetarySeriesSchema = z.object(MonetarySeriesShape);
const MoneyPerAreaSeriesShape = { ...GeographicSeriesShape, value_type: MoneyPerAreaFactSchema.shape.value_type, values: MoneyPerAreaFactSchema.shape.values };
const MoneyPerAreaSeriesSchema = z.object(MoneyPerAreaSeriesShape);
export const GeographicMarketTimeSeriesSchema = z.discriminatedUnion('value_type', [NumberSeriesSchema, PercentageSeriesSchema, MonetarySeriesSchema, MoneyPerAreaSeriesSchema]);
const GeographicRealEstateDataShape = {
    time_series: GeographicMarketTimeSeriesSchema.array(),
};
export const GeographicRealEstateDataSchema = z.object(GeographicRealEstateDataShape);
const GeographicMarketDataShape = {
    real_estate_data: GeographicRealEstateDataSchema,
};
export const GeographicMarketDataSchema = z.object(GeographicMarketDataShape);
